module.exports = __webpack_public_path__ + "static/media/3.fd24bf18.png";